import {Box, HStack, Text} from 'platform/foundation';
import styled from 'styled-components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER, Nullish, suffixTestId, TestIdProps} from 'shared/web';

interface FinancialProductResultRowProps extends TestIdProps {
  label: string;
  value: number | string | Nullish;
  emphasized?: boolean;
}

/** A row without a value keeps its place with a placeholder, so the panel never changes height. */
export function FinancialProductResultRow(props: FinancialProductResultRowProps) {
  return (
    <ResultRow $emphasized={props.emphasized} data-testid={suffixTestId('resultRow', props)}>
      <HStack justify="space-between" spacing={3} align="baseline">
        <Box opacity={props.emphasized ? 1 : 0.62} minWidth={0}>
          <Text
            size="small"
            color="inverted"
            alternative={props.emphasized}
            overflowWrap="anywhere"
          >
            {props.label}
          </Text>
        </Box>
        <Box minWidth={0}>
          <Text
            size="small"
            color="inverted"
            alternative={props.emphasized}
            align="right"
            overflowWrap="anywhere"
          >
            {isNilOrEmpty(props.value) ? EMPTY_PLACEHOLDER : props.value}
          </Text>
        </Box>
      </HStack>
    </ResultRow>
  );
}

const ResultRow = styled.div<{$emphasized?: boolean}>`
  padding-block: ${({theme}) => theme.getSize(2)};

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  & + & {
    border-top: ${({theme, $emphasized}) =>
      $emphasized
        ? 'none'
        : `thin solid color-mix(in srgb, ${theme.colors.text.inverted} 12%, transparent)`};
  }
`;
